/*
  Catalogue categories — fallback + theming defaults.
  ───────────────────────────────────────────────────────────────────────────
  Categories are now managed in the database (admin → Categories) and read
  live via the `useCategories()` hook. This file only provides:

    • FALLBACK_CATEGORIES — the original "big 4", used as the initial paint and
      offline fallback before/if the /api/categories request resolves.
    • DEFAULT_GRAD / DEFAULT_INK — theming applied to a category that has none,
      so a freshly-added collection still renders an intentional carousel wheel.
    • ICON_KEYS — the glyph keys CategoryIcon can draw (offered in the admin
      icon picker); any other value falls back to a generic glyph.

  Each entry carries display + theming used by the homepage carousels:
    grad   — background gradient for the wheel header / cards
    ink    — readable accent colour on that gradient
    blurb  — one-liner under the carousel title
*/
export const DEFAULT_GRAD = 'linear-gradient(135deg,#f3f0ff 0%,#ddd6fe 100%)';
export const DEFAULT_INK  = '#5b3aa6';

export const ICON_KEYS = ['sticks', 'skin', 'hair', 'peptides'];

export const FALLBACK_CATEGORIES = [
  {
    value: 'sticks',
    label: 'Sticks',
    icon: 'sticks',
    grad: 'linear-gradient(135deg,#ffe3ef 0%,#ffbcd9 100%)',
    ink: '#9d1d54',
    blurb: 'Swipe-on balms & multi-sticks for face, lips and glow-on-the-go.',
  },
  {
    value: 'skin',
    label: 'Skin',
    icon: 'skin',
    grad: 'linear-gradient(135deg,#ecf6ff 0%,#c5e2fb 100%)',
    ink: '#1b4a78',
    blurb: 'Cooling treatments, patches and rituals for fresh, dewy skin.',
  },
  {
    value: 'hair',
    label: 'Hair',
    icon: 'hair',
    grad: 'linear-gradient(135deg,#e9f8ef 0%,#c7ecd5 100%)',
    ink: '#1c5e35',
    blurb: 'Scalp therapies & root-reviving care for healthier, fuller hair.',
  },
  {
    value: 'peptides',
    label: 'Peptides',
    icon: 'peptides',
    grad: 'linear-gradient(135deg,#e9f1ff 0%,#c9ddfb 100%)',
    ink: '#143f73',
    blurb: 'Copper-peptide & advanced repair formulas for firmer skin.',
  },
];

/** Normalise a raw API/category record, filling in theming defaults. */
export function normalizeCategory(c) {
  return {
    id: c.id,
    value: c.value,
    label: c.label || c.value || '',
    blurb: c.blurb || '',
    grad: c.grad || DEFAULT_GRAD,
    ink: c.ink || DEFAULT_INK,
    icon: c.icon || c.value,
    sortOrder: c.sortOrder,
    isActive: c.isActive,
  };
}
